<template>
  <div v-if="isshow" class="moneyTable position">
    <div class="btn">
      <div v-if="!iscompile" class="radish-btn radish-btn-primary radish-btn-small" @click="iscompile = true">编辑</div>
      <div v-else class="radish-btn radish-btn-primary radish-btn-small" @click="iscompile = false">退出编辑</div>
      <!-- <el-button v-if="!iscompile" size="mini" @click="iscompile=true">编辑</el-button>
      <el-button v-else size="mini" @click="iscompile=false">退出编辑</el-button> -->
      <div class="componentclose" @click="isshow = false">X</div>
    </div>
    <div class="half">
      <header>
        <el-alert
          title="请选择所填的薪酬表类型：公司整体薪酬，部门薪酬，职能模块薪酬"
          type="error"
          description="填写完成后点击保存薪酬表会生成相应标签，再次点击改标签即可查看"
        ></el-alert>
        <el-cascader
          v-model="selectValue"
          expand-trigger="hover"
          :options="cascaderOption"
          size="mini"
          @change="handleChange"
        ></el-cascader>
        <i class="el-icon-question"></i>
        <div v-if="iscompile" class="radish-btn radish-btn-primary radish-btn-small" style="float:right" @click="save">
          保存薪酬表
        </div>
        <!-- <el-button size="mini" style="float:right" @click="save" v-if="iscompile" plain>保存薪酬表</el-button> -->
        <h3>{{ title }}</h3>
      </header>
      <section>
        <table>
          <tr>
            <td>操作</td>
            <td v-for="(item, index) in tabledata" :key="item.专业职级 + item.管理职级 + index">
              <span class="btn" @click="removeRow(index)">-</span>
            </td>
            <td><span class="btn" @click="addRow">+</span></td>
          </tr>

          <tr>
            <td>专业职级</td>
            <td v-for="(item, index) in tabledata" :key="item.专业职级 + index" class="selecttd">
              <el-select
                v-show="iscompile"
                v-model="item.专业职级"
                filterable
                allow-create
                placeholder
                size="mini"
                @change="_updateTableType(item, index, '专业职级')"
              >
                <el-option v-for="item in profission" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span v-show="!iscompile" id="readonly">{{ item.专业职级 }}</span>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>管理职级</td>
            <td v-for="(item, index) in tabledata" :key="item.管理职级 + index" class="selecttd">
              <el-select
                v-show="iscompile"
                v-model="item.管理职级"
                filterable
                size="mini"
                placeholder
                allow-create
                @change="_updateTableType(item, index, '管理职级')"
              >
                <el-option v-for="item in manage" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span v-show="!iscompile" id="readonly">{{ item.管理职级 }}</span>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>年限</td>
            <td v-for="(item, index) in tabledata" :key="item.专业职级 + item.管理职级 + index">
              <input v-show="iscompile" v-model="item.年限" />
              <span v-show="!iscompile" id="readonly">{{ item.年限 }}</span>
            </td>
            <td></td>
          </tr>
          <tr v-for="type in ['固薪', '奖金', '年薪', '指标']" :key="type">
            <td>
              <span>{{ type }}</span> <br />
              <span>（万）</span>
            </td>
            <td v-for="(item, index) in tabledata" :key="item.专业职级 + item.管理职级 + index">
              <input v-if="iscompile" v-model="item[type]" />
              <el-tooltip v-else class="item" effect="dark" :content="item[type]" placement="top">
                <span v-if="item[type]">***</span>
              </el-tooltip>
            </td>
            <td></td>
          </tr>
          <tr v-for="type in ['奖金机制', '奖金发放时间', '递延机制', '考核指标', '备注']" :key="type">
            <td>
              <span>{{ type }}</span>
            </td>
            <td :colspan="tabledata.length + 1">
              <el-input
                v-show="iscompile"
                v-model="tablecontent[type]"
                type="textarea"
                class="textarea"
                autosize
              ></el-input>
              <span v-show="!iscompile" id="readonly">{{ tablecontent[type] }}</span>
            </td>
          </tr>
        </table>
      </section>
    </div>
    <el-dialog title="选择表格要加kpi的用户" :visible.sync="kpiDialog" :close-on-click-modal="false" :modal="false" width="30%">
      <span>选择用户:</span>
      <el-select v-model="kpiValue" filterable placeholder="请选择">
        <el-option v-for="item in userOption" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveKpi">确 定</div>

      <!-- <el-button type="primary" @click="saveKpi">确 定</el-button> -->
    </el-dialog>
    <div class="half">
      <section v-if="iscompile">
        <div>
          <span>智能薪酬录入</span>
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="_analyze">解析文本</div>

          <!-- <el-button type="primary" size="mini" @click="_analyze" plain>解析文本</el-button> -->
        </div>
        <p v-if="showalert" class="alert" @click="showalert = false">
          职级用"Enter"分开（回车分行） <br />例： <br />A <br />SA <br />VP <br />D <br />薪酬用 "-" 分开
          <br />例子：AN-2-30-54,代表：AN(职级)-2（月税前固定薪酬，单位万）-30（年税前奖金）-54（税前年总薪酬）
          <br />如果不知道，填写0. <br />回车区分行。
        </p>
        <p v-else class="alert" @click="showalert = true">显示规则</p>
        <el-input
          v-model="analyzeStr"
          type="textarea"
          :rows="10"
          placeholder="A-10-20-40
SA-15-30-60
VP-20-40-100
SVP
奖金机制：“大锅饭”式分配,2017年起，开始尝试固薪、奖金“背靠背”，依照个人情况重新制定，以标准薪酬为参考上下浮动。
奖金发放时间：项目奖，各项目完成时，发放占项目收入10%的奖金，给承揽、做、销个人；年终奖，预计将在7-8月，核算发放。
递延机制：不递延
备注："
        ></el-input>
      </section>
      <section>
        <ul>
          <li>
            <span>已设置部门：</span>
            <div>
              <el-tag
                v-for="(item, index) in hasSetTable.department"
                :key="item"
                size="mini"
                style="margin:0 4px 8px;cursor:pointer;"
                type="success"
                closable
                @close="deleteDepartment(item, index)"
                @click.native="showDepartment(item)"
                >{{ item }}</el-tag
              >
            </div>
          </li>
          <li>
            <span>已设置职能模块：</span>
            <div>
              <el-tag
                v-for="(item, index) in hasSetTable.category"
                :key="item"
                size="mini"
                style="margin:0 4px 8px;cursor:pointer;"
                type="success"
                closable
                @close="deleteCategory(item, index)"
                @click.native="showCategory(item)"
                >{{ item }}</el-tag
              >
            </div>
          </li>
          <li>
            <span>已设置公司薪酬：</span>
            <div>
              <el-tag
                v-for="(item, index) in companymoney"
                :key="index + 2"
                size="mini"
                style="margin:0 4px 8px;cursor:pointer;"
                type="success"
                closable
                @close="deleteCompany"
                @click.native="showCompany"
                >{{ companyName }}</el-tag
              >
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import { moneyTable, moneyContent } from '../../statistics/variant/table.js'
import * as fixedvariant from '../../statistics/variant/fixedvariant.js'

export default {
  props: {
    companyName: { type: String, default: '' },
  },
  data() {
    return {
      isshow: false,
      department: '',
      category: '',
      title: '部门奖金薪酬表',
      analyzeStr: '',
      iscompile: false,
      tableType: '',
      kpiDialog: false,
      kpiValue: '',
      userOption: [],
      manage: fixedvariant.管理职级表头,
      profission: fixedvariant.专业职级表头,
      departmentOption: [],
      categoryData: {},
      tabledata: JSON.parse(JSON.stringify(moneyTable)),
      tablecontent: JSON.parse(JSON.stringify(moneyContent)),
      hasSetTable: { department: [], category: [] },
      showalert: false,
      cascaderOption: [
        {
          value: '公司整体薪酬',
          label: '公司整体薪酬',
        },
      ],
      selectValue: [],
      companymoney: [],
    }
  },
  watch: {
    companyName(newValue, oldValue) {
      if (newValue) this.getData()
    },
  },
  async mounted() {
    this.setOption()
  },
  methods: {
    async deleteCompany() {
      const res = await window.app.service('company').modifyCompany({
        query: { 简称: this.companyName },
        data: { companyMoneyTable: null },
      })
      if (res.status == 200) this.companymoney = []
    },
    async setOption() {
      if (!app.accounts) {
        await app.getUsers()
      }
      const notshow = ['admin', 'test', 'wpgao', 'cctang', 'test1', 'yezuochang', 'hktang']
      this.userOption = app.accounts.filter(val => !notshow.includes(val))
      if (!app.categories) {
        await app.getCats()
      }
      this.categoryOption = app.categories
    },
    handleChange(val) {
      const type = val[0]
      const item = val[1]
      if (type === '部门薪酬') {
        this.showDepartment(item)
      } else if (type === '职能模块薪酬') {
        this.showCategory(item)
      } else if (type === '公司整体薪酬') {
        this.showCompany()
      }
    },
    async open(type, name) {
      await this.getData()
      if (type === '部门薪酬') {
        this.showDepartment(name)
      } else if (type === '职能模块薪酬') {
        this.showCategory(name)
      } else {
        this.showCompany()
      }
      this.isshow = true
    },
    init() {
      this.tabledata = JSON.parse(JSON.stringify(moneyTable))
      this.tablecontent = JSON.parse(JSON.stringify(moneyContent))
    },
    showCompany() {
      this.selectValue.splice(0, 1, '公司整体薪酬')
      this.selectValue.splice(1, 1, '')
      this.title = '公司整体薪酬'
      if (this.companymoney.length > 0) {
        this.tabledata = this.companymoney[0].table || JSON.parse(JSON.stringify(moneyTable))
        this.tablecontent = this.companymoney[0].content || JSON.parse(JSON.stringify(moneyContent))
      } else {
        this.tabledata = JSON.parse(JSON.stringify(moneyTable))
        this.tablecontent = JSON.parse(JSON.stringify(moneyContent))
      }
    },
    analyzeMoney(str) {
      const val = str.split('-')
      if (val.length === 0) {
        return false
      }
      const obj = {
        专业职级: '',
        管理职级: '',
        固薪: val[1] ? val[1].replace(/[^0-9]/gi, '') : '',
        奖金: val[2] ? val[2].replace(/[^0-9]/gi, '') : '',
        年薪: val[3] ? val[3].replace(/[^0-9]/gi, '') : '',
      }
      const ckeckkeys = ['固薪', '奖金', '年薪']
      ckeckkeys.map(v => {
        if (obj[v] == '0') {
          obj[v] = ''
        }
      })
      const type = this.trim(val[0].replace(/[;；]/g, ''))
      let temptype = this.trim(val[0])
      if (!type) {
        return
      }
      const reg = /[0-9a-zA-Z]/
      for (let i = 0, len = type.length; i < len; i += 1) {
        temptype = temptype.replace(reg, '')
      }
      if (temptype === '') {
        obj.专业职级 = type
      } else {
        obj.管理职级 = type
      }
      for (const key in obj) {
        obj[key] = this.trim(obj[key])
      }
      return obj
    },
    analyzeRemark(str) {
      const keyarr = ['奖金机制', '奖金发放时间', '递延机制', '备注']
      const result = str.replace(/：/g, ':').split(':')
      const key = result[0]
      result.splice(0, 1)
      const val = result.join('')
      if (keyarr.includes(key)) {
        this.tablecontent[key] = val
      }
    },
    removeRow(index) {
      this.tabledata.splice(index, 1)
    },
    addRow() {
      this.tabledata.push({
        专业职级: '',
        管理职级: '',
        固薪: '',
        奖金: '',
        年薪: '',
      })
    },
    showDepartment(item) {
      this.selectValue.splice(0, 1, '部门薪酬')
      this.selectValue.splice(1, 1, item)
      this.department = item
      this._chooseDepartment()
    },
    showCategory(item) {
      this.selectValue.splice(0, 1, '职能模块薪酬')
      this.selectValue.splice(1, 1, item)
      this.category = item
      this._chooseCategory()
    },
    async _chooseDepartment() {
      const result = await window.app
        .service('company')
        .getDepartmentMoney({ 公司: this.companyName, 部门: this.department })
      if (result.status === 'success') {
        this.title = '部门奖金薪酬表'
        this.category = ''
        if (result.data) {
          this.tabledata = result.data.table || JSON.parse(JSON.stringify(moneyTable))
          this.tablecontent = result.data.content || JSON.parse(JSON.stringify(moneyContent))
        } else {
          this.init()
        }
      } else {
        this.$message('获取数据出错')
      }
    },
    async _chooseCategory() {
      this.title = '职能模块奖金薪酬表'
      this.department = ''
      if (this.categoryData[this.category]) {
        this.tabledata = this.categoryData[this.category].table || JSON.parse(JSON.stringify(moneyTable))
        this.tablecontent = this.categoryData[this.category].content || JSON.parse(JSON.stringify(moneyContent))
      } else {
        this.init()
      }
    },
    _updateTableType(item, index, type) {
      if (type === '专业职级' && item.专业职级) {
        item.管理职级 = ''
      } else if (type === '管理职级' && item.管理职级) {
        item.专业职级 = ''
      }
      this.tabledata.splice(index, 1, item)
    },
    _analyze() {
      const result = []
      const str = this.analyzeStr.replace(/；/g, ';').replace(/：/g, ':')
      const levelarr = str.split(/\n/g)
      levelarr.map(item => {
        if (!item) {
          return
        }
        if (
          item.includes('奖金机制') ||
          item.includes('奖金发放时间') ||
          item.includes('递延机制') ||
          item.includes('备注')
        ) {
          this.analyzeRemark(item)
        } else {
          const obj = this.analyzeMoney(item)
          if (obj) {
            result.push(obj)
          }
        }
      })
      result.map(val => {
        let flag = true // 能否添加列
        this.tabledata.map(item => {
          const issame =
            (item.专业职级 && item.专业职级.toUpperCase() === val.专业职级.toUpperCase()) ||
            (item.管理职级 && item.管理职级 === val.管理职级)
          if (issame) {
            flag = false
            item.固薪 = val.固薪
            item.奖金 = val.奖金
            item.年薪 = val.年薪
          }
        })
        if (flag) {
          this.tabledata.push(val)
        }
      })
      this.analyzeStr = ''
    },
    profissionQuerySearch(queryString, cb) {
      const restaurants = []
      this.profission.map(v => {
        restaurants.push({ value: v })
      })
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    manageQuerySearch(queryString, cb) {
      const restaurants = []
      this.manage.map(v => {
        restaurants.push({ value: v })
      })
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },
    async save() {
      const data = { content: this.tablecontent, table: this.tabledata }
      if (this.selectValue[0] === '部门薪酬' && this.department != '') {
        const result = await window.app.service('company').updateDepartmentMoney({
          公司: this.companyName,
          部门: this.department,
          data: data,
        })
        if (result.status === 'success' || result.status === 200) this.$message('保存成功')
        if (!this.hasSetTable.department.includes(this.department)) {
          this.hasSetTable.department.push(this.department)
        }
        this.$emit('refreshTable')
      } else if (this.selectValue[0] === '职能模块薪酬' && this.category != '') {
        this.categoryData[this.category] = data
        const result = await window.app.service('company').updateCategoryMoney({
          公司: this.companyName,
          data: this.categoryData,
        })
        if (result.status === 'success' || result.status === 200) this.$message('保存成功')
        if (!this.hasSetTable.category.includes(this.category)) {
          this.hasSetTable.category.push(this.category)
        }
        this.$emit('refreshTable')
      } else if (this.selectValue[0] === '公司整体薪酬') {
        const result = await app.service('company').modifyCompany({
          query: { 简称: this.companyName },
          data: { companyMoneyTable: data },
        })
        if (result.status === 'success' || result.status === 200) this.$message('保存成功')
        this.companymoney = [data]
      }
      // 判断是否是行政保存的薪酬表，如果是，弹出选项选择给谁加KPI，不是则自动加给user
      if (app.user.角色 && app.user.角色.includes('行政')) {
        this.kpiDialog = true
        this.kpiValue = ''
      } else {
        this.kpiValue = app.user.account
        this.saveKpi()
      }
    },
    async saveKpi() {
      const option = {
        type: '薪酬数据',
        account: this.kpiValue,
        content: {
          公司: this.companyName,
        },
      }
      if (this.selectValue[0] === '职能模块薪酬') {
        option.content.type = 'category'
        option.content.detail = this.category
      } else if (this.selectValue[0] === '部门薪酬') {
        option.content.type = 'department'
        option.content.detail = this.department
      } else if (this.selectValue[0] === '公司整体薪酬') {
        option.content.type = 'company'
      }
      await app.service('radish').addKpi(option)
      this.kpiDialog = false
      this.kpiValue = ''
    },
    async deleteDepartment(item, index) {
      const result = await window.app.service('company').deleteDepartmentMoney({
        公司: this.companyName,
        部门: item,
        user: app.user.account,
      })
      if (result.status == 200) {
        if (this.department == item) {
          this.init()
        }
        this.hasSetTable.department.splice(index, 1)
        this.$emit('refreshTable')
      } else {
        this.$message('删除失败，请稍后重试')
      }
    },
    async deleteCategory(item, index) {
      const deleteCategoryMoneyTable = {
        user: app.user.account,
        time: new Date().getTime(),
        data: JSON.parse(JSON.stringify(this.categoryData[item])),
      }
      delete this.categoryData[item]
      const result = await window.app.service('company').updateCategoryMoney({
        公司: this.companyName,
        data: this.categoryData,
        deleteCategoryMoneyTable: deleteCategoryMoneyTable,
      })
      if (result.status === 'success') {
        if (this.category == item) this.init()
        this.hasSetTable.category.splice(index, 1)
        this.$emit('refreshTable')
      } else {
        this.$message('删除失败，请稍后重试')
      }
    },
    trim(str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    async getData() {
      this.cascaderOption = [{ value: '公司整体薪酬', label: '公司整体薪酬' }]
      const result = await app.service('company').getDepartments(this.companyName)
      if (result.status === 'success') {
        const arr = result.data.map(v => ({ value: v, label: v }))
        this.cascaderOption.splice(1, 0, {
          value: '部门薪酬',
          label: '部门薪酬',
          children: arr,
        })
      }
      const categoryArr = this.categoryOption.map(v => ({ value: v.名称, label: v.名称 }))
      this.cascaderOption.splice(1, 0, {
        value: '职能模块薪酬',
        label: '职能模块薪酬',
        children: categoryArr,
      })
      const categoryResult = await app.service('company').getCategoryMoney({ 公司: this.companyName })
      if (categoryResult.status == 200) {
        this.categoryData = categoryResult.data || {}
      }
      const hasSetResult = await app.service('company').getHasSetMoneyTable({ 公司: this.companyName })
      if (hasSetResult.status == 200) {
        this.hasSetTable.department = hasSetResult.data.department
        this.hasSetTable.category = hasSetResult.data.category
        if (hasSetResult.data.company) this.companymoney = [hasSetResult.data.company]
      }
    },
  },
}
</script>
<style>
.selecttd .el-input .el-input__inner {
  padding: 0;
  border: 0;
}
.selecttd .el-icon-arrow-up:after,
.selecttd .el-icon-arrow-up:before {
  content: '';
}
td .textarea .el-textarea__inner {
  border: 0;
}
</style>
<style src="../../statistics/css/moneyTable.css" scoped></style>
